import React from 'react'
import { useEventLogging } from '@packages/jslib'

import { FontSizeButtonInfoType } from './index'

type FontSizeType = {
  fontSizeButtonInfo: FontSizeButtonInfoType[]
  fontSize: string
  setFontSize: (size: string) => void
}
export default function FontSize(props: FontSizeType) {
  const { trackButtonClick } = useEventLogging()
  const { fontSizeButtonInfo, fontSize, setFontSize } = props
  const fontSizeValues: Record<string, number> = {
    small: 80,
    base: 100,
    large: 120,
  }
  return (
    <div className="flex my-auto">
      <div className="title text-base w-[30px] flex items-center font-normal mb-0.5 mx-3">
        글자 크기
      </div>
      <div className="button-wrap text-base flex flex-column w-[120px] 1.1xl:w-[164px] justify-between">
        {fontSizeButtonInfo.map((data) => (
          <div key={data.size} className={`fs-button__${data.size}}`}>
            <button
              className={`w-8 1.1xl:w-11 h-8 1.1xl:h-11 rounded-md font-medium ${
                fontSize === data.size ? 'bg-bosalpim text-white' : 'bg-white text-primary-text'
              } ${data.className}`}
              onClick={() => {
                trackButtonClick({
                  name: 'Text Size Adjustment',
                  properties: {
                    text_size: fontSizeValues[data.size],
                  },
                })
                setFontSize(data.size)
              }}
            >
              가
            </button>
            <p
              className={`text-xs text-center pt-0.5 ${
                fontSize === data.size ? 'text-primary-text' : 'text-white'
              }`}
            >
              {data.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
